import React, { useState } from 'react';
import { 
  FaUser, 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt, 
  FaPaperPlane,
  FaHeadset,
  FaClock,
  FaCheckCircle,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaWhatsapp,
  FaInfoCircle,
  FaArrowRight,
  FaMapPin,
  FaBuilding
} from 'react-icons/fa';
import '../style.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({ name: '', subject: '', email: '', phone: '', message: '' });
      setTimeout(() => setIsSubmitted(false), 4000);
    }, 1200);
  };

  const contactCards = [
    {
      icon: <FaPhone />,
      title: "Call Support",
      info: "+91 9415799879",
      desc: "24/7 Available",
      color: "#2ecc71",
      link: "tel:+919415799879"
    },
    {
      icon: <FaWhatsapp />,
      title: "WhatsApp",
      info: "+91 9415799879",
      desc: "Instant Reply",
      color: "#25D366",
      link: "https://wa.me/919415799879"
    },
    {
      icon: <FaClock />,
      title: "Office Hours",
      info: "8AM - 10PM",
      desc: "Mon-Sunday",
      color: "#9b59b6"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Visit Office",
      info: "Gandhi Nagar",
      desc: "Sigra, Varanasi",
      color: "#e74c3c"
    }
  ];

  return (
    <div className="contact-us-wrapper">
      {/* Header Section */}
      <div className="contact-us-header">
        <div className="contact-header-content">
          <h1>Contact Us</h1>
          <p>Get premium taxi service support in Varanasi</p>
        </div>
      </div>

      <div className="contact-us-container">
        {/* Main Content */}
        <div className="contact-us-grid">
          {/* Contact Form */}
          <div className="contact-form-area">
            <div className="form-area-header">
              <h2>Send Your Message</h2>
              <p>Fill the form below for quick response</p>
            </div>

            {isSubmitted && (
              <div className="form-success-msg">
                <FaCheckCircle />
                <div>
                  <h4>Success!</h4>
                  <p>We'll contact you soon.</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-us-form">
              <div className="form-fields-row">
                <div className="form-field-box">
                  <FaUser className="field-icon" />
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-field-box">
                  <FaInfoCircle className="field-icon" />
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-fields-row">
                <div className="form-field-box">
                  <FaEnvelope className="field-icon" />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-field-box">
                  <FaPhone className="field-icon" />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-field-box message-box">
                <FaEnvelope className="field-icon" />
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="3"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="form-submit-btn" disabled={isSubmitting}>
                {isSubmitting ? (
                  <span>Sending...</span>
                ) : (
                  <>
                    <FaPaperPlane /> Send Message
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info-area">
            <div className="info-area-header">
              <h2>Contact Details</h2>
              <p>Multiple ways to reach us</p>
            </div>

            {/* Compact Contact Cards */}
            <div className="contact-details-cards">
              {contactCards.map((item, index) => (
                <div key={index} className="detail-card" style={{ '--card-color': item.color }}>
                  <div className="detail-card-icon" style={{ background: item.color }}>
                    {item.icon}
                  </div>
                  <div className="detail-card-content">
                    <h4>{item.title}</h4>
                    {item.link ? (
                      <a href={item.link} className="detail-card-link">{item.info}</a>
                    ) : (
                      <p className="detail-card-text">{item.info}</p>
                    )}
                    <small>{item.desc}</small>
                  </div>
                </div>
              ))}
            </div>

            {/* Address Information */}
            <div className="address-info-box">
              <div className="address-title">
                <FaMapPin />
                <h3>Our Address</h3>
              </div>
              <div className="address-details">
                <div className="address-item">
                  <strong>Office Address:</strong>
                  <p>D.58/12-A, Plot No 84, Gandhi Nagar, Sigra, Varanasi, Uttar Pradesh 221002</p>
                </div>
                <div className="address-item">
                  <strong>Head Office:</strong>
                  <p>D.58/12-A, Plot No 84, Gandhi Nagar, Sigra, Varanasi, Uttar Pradesh 221002</p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="social-connect-box">
              <h3>Connect With Us</h3>
              <div className="social-buttons-grid">
                <a href="#" className="social-btn fb-btn">
                  <FaFacebook /> Facebook
                </a>
                <a href="#" className="social-btn tw-btn">
                  <FaTwitter /> Twitter
                </a>
                <a href="#" className="social-btn ig-btn">
                  <FaInstagram /> Instagram
                </a>
                <a href="https://wa.me/919415799879" className="social-btn wa-btn">
                  <FaWhatsapp /> WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Map & Emergency Section */}
        <div className="contact-bottom-section">
          {/* Map */}
          <div className="location-map-box">
            <div className="map-title">
              <FaMapMarkerAlt />
              <h3>Our Location</h3>
            </div>
            <div className="map-container">
              <iframe
                title="Varanasi Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.874433540271!2d82.98721431501124!3d25.281437083858498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e2db76febcf4d%3A0x68131710853ff8b5!2sVaranasi%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1649234567890!5m2!1sen!2sin"
                width="100%"
                height="180"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <p className="map-address">Gandhi Nagar, Sigra, Varanasi - 221002</p>
          </div>

          {/* Emergency Contact */}
          <div className="emergency-contact-box">
            <div className="emergency-content">
              <FaHeadset className="emergency-phone-icon" />
              <div className="emergency-text">
                <h3>Need Immediate Help?</h3>
                <p>24/7 Emergency taxi booking support</p>
              </div>
              <a href="tel:+919415799879" className="emergency-call-btn">
                <FaPhone /> Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;